module.exports = "/static/media/logo.2c569cdf.png";